type QRCodeProps = {
  base64Data: string // The base64 string for the image
}

export default function QrCode({ base64Data }: QRCodeProps) {
  return (
    <div>
      <img src={base64Data} alt="QR Code" />
    </div>
  )
}
